"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaylineHead = void 0;
var react_1 = __importDefault(require("react"));
var react_helmet_1 = require("react-helmet");
exports.PaylineHead = function (_a) {
    var _b = _a.production, production = _b === void 0 ? false : _b;
    var baseUrl = production ? 'https://payment.payline.com' : 'https://homologation-payment.payline.com';
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("script", { src: baseUrl + "/scripts/widget-min.js" }),
        react_1.default.createElement("link", { href: baseUrl + "/styles/widget-min.css", rel: "stylesheet" })));
};
var PaylineProvider = function (_a) {
    var _b = _a.production, production = _b === void 0 ? false : _b, children = _a.children;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_helmet_1.Helmet, null,
            react_1.default.createElement(exports.PaylineHead, { production: production })),
        children));
};
exports.default = PaylineProvider;
//# sourceMappingURL=PaylineProvider.js.map